// src/services/alphaVantage/config.ts
export enum ApiTier {
  FREE = 'free',
  BASIC = 'basic',
  PREMIUM = 'premium',
  ENTERPRISE = 'enterprise'
}

interface ApiConfig {
  maxCallsPerMinute: number;
  maxCallsPerDay: number;
  endpoints: string[];
}

export const API_CONFIG: Record<ApiTier, ApiConfig> = {
  [ApiTier.FREE]: {
    maxCallsPerMinute: 5,
    maxCallsPerDay: 500,
    endpoints: ['TIME_SERIES_DAILY', 'TIME_SERIES_WEEKLY']
  },
  [ApiTier.BASIC]: {
    maxCallsPerMinute: 15,
    maxCallsPerDay: 1500,
    endpoints: ['TIME_SERIES_DAILY', 'TIME_SERIES_INTRADAY', 'TIME_SERIES_WEEKLY']
  },
  [ApiTier.PREMIUM]: {
    maxCallsPerMinute: 60,
    maxCallsPerDay: 5000,
    endpoints: ['TIME_SERIES_DAILY', 'TIME_SERIES_INTRADAY', 'GLOBAL_QUOTE', 'TIME_SERIES_WEEKLY']
  },
  [ApiTier.ENTERPRISE]: {
    maxCallsPerMinute: 120,
    maxCallsPerDay: 10000,
    endpoints: ['TIME_SERIES_DAILY', 'TIME_SERIES_INTRADAY', 'GLOBAL_QUOTE', 'TIME_SERIES_WEEKLY']
  }
};
